<template>
    <span
        v-html="$t('notification.reservationCreatedPlan', {name:$_.get(activity, 'actorUser.name'),title:$_.get(activity, 'payload.title'),date: $_.get(activity, 'payload.customProgramDates.startDate') })"></span>
</template>
<script>
export default {
    name: "ReservationCreated",
    props: {
        activity: {
            type: Object,
            default: () => ({}),
        },
    },
};
</script>
<style></style>
